import "react-native-gesture-handler";
import React from "react";
import { useWindowDimensions } from "react-native";
import { store } from "./src/store";
import { Provider as ReduxProvider } from "react-redux";
import Navigation from "./src/navigation";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { ThemeProvider } from "./src/theme";
import { Background } from "./src/components/components";
import FlashMessage from "react-native-flash-message";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";

export default () => {
  let { height } = useWindowDimensions();
  return (
    <ReduxProvider store={store}>
      <ThemeProvider>
        <Background>
          <SafeAreaProvider>
            <KeyboardAwareScrollView
              contentContainerStyle={{ height, width: "100%" }}
            >
              <Navigation />
              <FlashMessage position="center" />
            </KeyboardAwareScrollView>
          </SafeAreaProvider>
        </Background>
      </ThemeProvider>
    </ReduxProvider>
  );
};
